module.exports = __webpack_public_path__ + "img/465128-1.7c03e502.png";